<ng-template #modalEmailPreview let-c="close" let-d="dismiss">
  <wsb-modal primaryButtonText="{{ 'common_cancel' | translate }}" (primary)="d()" (dismiss)="d()" title="{{ 'mail_preview' | translate }}">
    <div body>
      <div [innerHtml]="selectedEmailPreview"></div>
    </div>
  </wsb-modal>
</ng-template>
<ng-template #modalConfirmDelete let-c="close" let-d="dismiss">
  <wsb-modal
    cancelButtonEnable="true"
    cancelButtonText="{{ 'common_cancel' | translate }}"
    primaryButtonText="{{ 'common_ok' | translate }}"
    (primary)="closeDelete()"
    (dismiss)="d()"
    title="{{ 'mail_preview' | translate }}"
  >
    <div body>
      <div translate>mail_delete_confirm</div>
    </div>
  </wsb-modal>
</ng-template>

<wsb-atlas-grid
  #grid
  [@gridIsLoaded]="gridAnimationState"
  class="atlas-grid-simplest"
  class="mt-2"
  [columnDefs]="tableColumnsDefs"
  [options]="tableGridOptions"
  [showFilters]="true"
  [rowData]="tableRowData"
  [components]="components"
>
</wsb-atlas-grid>
